<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

  <form #f="ngForm" (ngSubmit)="SaveUpdateTemplate()" novalidate>
    <div class="row m-0 col-md-12 p-0 formborder" style="align-items: flex-end; padding: 0.625rem 0.9375rem !important;">
      <div class="col-md-4">
        <span class="required-lable">Create/Modify</span>
        <select
          name="AddType"
          id="AddType"
          class="form-control input-text-css"
          [(ngModel)]="AddType"
          (change)="OnChangeType()"
          #refAddType="ngModel"
          required
          [ngClass]="{
            'is-invalid': f.submitted && refAddType.invalid,
            'alert-warning':
              refAddType.invalid && (refAddType.dirty || refAddType.touched)
          }"
        >
          <option value="">Select Action</option>
          <option value="Create">Create New</option>
          <option value="Modify">Modify Existing</option>
        </select>
      </div>

      <div class="col-md-4" *ngIf="AddType === 'Modify'">
        <span class="required-lable">Select Template</span>
        <select
          name="TemplateId"
          id="TemplateId"
          class="form-control input-text-css"
          [(ngModel)]="TemplateId"
          #refTemplateId="ngModel"
          required
          (change)="getEmailTemplate()"
          [ngClass]="{
            'is-invalid': f.submitted && refTemplateId.invalid,
            'alert-warning':
              refTemplateId.invalid &&
              (refTemplateId.dirty || refTemplateId.touched)
          }"
        >
          <option value="">Select Template</option>
          <option
            *ngFor="let row of TemplateDropdown"
            [value]="row.Mail_Template_Id"
          >
            {{
              row.StepName.split("$")[1] !== undefined
                ? row.StepName.split("$")[1]
                : row.StepName
            }}
          </option>
        </select>
      </div>

      <div class="col-md-4" *ngIf="AddType === 'Create'">
        <span class="required-lable">Template Name</span>
        <input
          type="text"
          name="TemplateName"
          id="TemplateName"
          class="form-control input-text-css"
          [(ngModel)]="TemplateName"
          #refTemplateName="ngModel"
          placeholder="Enter new template name"
          required
          [ngClass]="{
            'is-invalid': f.submitted && refTemplateName.invalid,
            'alert-warning':
              refTemplateName.invalid &&
              (refTemplateName.dirty || refTemplateName.touched)
          }"
        />
      </div>
    </div>

    <!-- Subject and Body Section -->
    <ng-container *ngIf="AddType">
      <!-- Email Subject -->
      <div class="row m-0 col-md-12 p-0 formborder" style="align-items: flex-end; padding: 0.625rem 0.9375rem !important;">
<div class="col-md-12">
  <span class="required-lable">Email Subject</span>

  <div class="form-control input-text-css contenteditable-subject"
       contenteditable="true"
       (input)="onSubjectInput($event)"
       (blur)="onSubjectBlur()"
       (drop)="onSubjectDrop($event, $event.target)"
       (dragover)="onDragOver($event)"
       (dragenter)="onDragOver($event)"
       (keydown)="onSubjectKeydown($event)"  
       placeholder="Enter email subject line (you can insert placeholders here)"
       [ngClass]="{
         'is-invalid': f.submitted && refSubject.invalid,
         'alert-warning': refSubject.invalid && (refSubject.dirty || refSubject.touched)
       }">
  </div>

  <!-- hidden input still handles ngModel + validation -->
  <input type="hidden"
         name="Subject"
         #refSubject="ngModel"
         [(ngModel)]="Subject"
         required />
</div>

      </div>

      <!-- Email Body Editor -->
      <div class="row m-0 formborder" style="padding: 1.875rem 0 !important">
        <div class="col-md-9 p-0">
          <div class="container">
            <form [formGroup]="form">
              <button
                type="button"
                class="btn btn-sm btn-light mb-2"
                (click)="openLinkModal('facebook')"
              >
                <i class="fa-brands fa-facebook social-icon facebook"></i>
              </button>

              <button
                type="button"
                class="btn btn-sm btn-light mb-2"
                (click)="openLinkModal('linkedin')"
              >
                <i class="fa-brands fa-linkedin social-icon linkedin"></i>
              </button>

              <button
                type="button"
                class="btn btn-sm btn-light mb-2"
                (click)="openLinkModal('instagram')"
              >
                <i class="fa-brands fa-instagram social-icon instagram"></i>
              </button>

              <button
                type="button"
                class="btn btn-sm btn-light mb-2"
                (click)="openLinkModal('twitter')"
              >
                <i
                  class="fa-brands fa-square-x-twitter social-icon twitter"
                ></i>
              </button>

              <button
                type="button"
                class="btn btn-sm btn-light fs-12 mb-2"
                style="background-color: #000; color: #fff; height: 1.5625rem"
                (click)="AddCompanyLogo()"
              >
                Logo
              </button>

              <angular-editor
                #editor
                autofocus="true"
                id="editor2"
                formControlName="signature"
                [config]="config2"
                [(ngModel)]="templateData"
                sanitize="false"
              ></angular-editor>
            </form>
          </div>
        </div>

        <!-- Side Menu: Placeholders (Clean & Working) -->
        <div class="col-md-3 submenu" *ngIf="JsonData && JsonData.length > 0">
          <input
            type="text"
            id="searchText"
            name="searchText"
            class="form-control input-text-css mb-3"
            [(ngModel)]="searchText"
            placeholder="Search placeholders..."
            style="position: sticky; top: 0.1875rem; width: 100%; z-index: 10"
          />

          <!-- New wrapper for scrollable list -->
          <div class="sidebar-scrollable">
            <div
              class="placeholder-item lead fs-14 mb-2 p-2 border rounded bg-light d-block"
              *ngFor="let x of JsonData | search: 'SideMenuName' : searchText"
              (click)="insertPlaceholderAtCursor(x.SideMenuName, subjectInput)"
              [draggable]="true"
              (dragstart)="onDragStart($event, x.SideMenuName)"
              title="Click or drag to insert: {{ x.SideMenuName }}"
            >
              <p class="mb-0 text-primary font-weight-medium">
                {{ x.SideMenuName }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="text-right mb-2">
        <button
          type="button"
          (click)="SaveUpdateTemplate()"
          class="btn font-size-12 button-btn"
          [class.spinner]="loading"
          [disabled]="!f.form.valid || loading"
        >
          Save Template
        </button>
      </div>
    </ng-container>
  </form>
</div>
<div
  class="modal fade in"
  id="linkModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Enter {{ selectedPlatform }} Link
        </h6>
        <button
          type="button"
          (click)="closeModal()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><i class="far text-black fa-times-circle"></i
          ></span>
        </button>
      </div>
      <div class="modal-body" style="border: none">
        <div class="table-responsive">
          <form #f="ngForm" novalidate class="formborder">
            <div class="d-flex flex-column">
              <div class="col-md-12">
                <span class="required-lable">
                  {{ selectedPlatform }} Link
                </span>
                <input
                  type="text"
                  name="Link"
                  id="Link"
                  [(ngModel)]="Link"
                  placeholder="Enter {{ selectedPlatform }} Link"
                  class="form-control input-text-css w-full"
                  #refLink="ngModel"
                  required
                  [ngClass]="{
                    'is-invalid': f.submitted && refLink.invalid,
                    'alert-warning':
                      refLink.invalid &&
                      (refLink.dirty || refLink.touched || refLink.untouched)
                  }"
                />
              </div>
            </div>
            <div class="d-flex justify-content-end mr-3 mt-2">
              <button
                type="button"
                (click)="onsaveLink(Link)"
                class="btn font-size-12 button-btn"
                *ngIf="Link"
                [disabled]="!Link"
                [class.spinner]="loading"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
